module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"NOT FOUND","message":"We could not find what you were looking for. Are you sure you are in the right place?"},"da":{"title":"IKKE FUNDET","message":"Vi kunne ikke finde hvad du ledte efter. Er du sikker på at du er det rigtige sted?"}}')
  delete Component.options._Ctor
}
